import React from "react";
import { Link, useLocation } from "react-router-dom";

const ClientPaymentFailure = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const txnid = params.get("txnid") || "";
  const noticeId = params.get("noticeId") || "";
  const reason = params.get("reason") || "Payment failed or was cancelled.";

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#fff5f5", padding: "24px" }}>
      <div style={{ background: "#fff", borderRadius: "16px", boxShadow: "0 4px 24px rgba(200,50,50,0.08)", padding: "48px 40px", maxWidth: "480px", width: "100%", textAlign: "center" }}>
        <div style={{ fontSize: "56px", marginBottom: "16px" }}>❌</div>
        <h2 style={{ color: "#c0392b", fontWeight: 700, marginBottom: "8px" }}>Payment Failed</h2>
        <p style={{ color: "#5b7088", marginBottom: "24px" }}>Your payment could not be completed. Please try again.</p>

        {(txnid || noticeId || reason) && (
          <div style={{ background: "#fff5f5", border: "1px solid #f5c6c6", borderRadius: "10px", padding: "16px", marginBottom: "24px", textAlign: "left" }}>
            {noticeId && <div style={{ marginBottom: "6px" }}><span style={{ color: "#6d8298", fontSize: "13px" }}>Notice ID</span><br /><strong style={{ color: "#102a43" }}>{noticeId}</strong></div>}
            {reason && <div style={{ marginBottom: txnid ? "6px" : "0" }}><span style={{ color: "#6d8298", fontSize: "13px" }}>Reason</span><br /><strong style={{ color: "#c0392b" }}>{decodeURIComponent(reason)}</strong></div>}
            {txnid && <div><span style={{ color: "#6d8298", fontSize: "13px" }}>Transaction ID</span><br /><strong style={{ color: "#102a43", fontSize: "13px", wordBreak: "break-all" }}>{txnid}</strong></div>}
          </div>
        )}

        <Link to="/client-my-notices" style={{ display: "inline-block", background: "#175c8f", color: "#fff", padding: "12px 28px", borderRadius: "8px", textDecoration: "none", fontWeight: 600 }}>
          Back to My Notices
        </Link>
      </div>
    </div>
  );
};

export default ClientPaymentFailure;
